import { ReactNode } from "react";
import { QueryParamProvider, QueryParamConfigMap } from "use-query-params";
import queryString from "query-string";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

export type PageQueryParams = QueryParamConfigMap;

function QueryProvider({ children }: { children: ReactNode }) {
  return (
    <QueryParamProvider
      adapter={ReactRouter6Adapter}
      options={{
        searchStringToObject: queryString.parse,
        objectToSearchString: queryString.stringify,
      }}
    >
      {children}
    </QueryParamProvider>
  );
}

export default QueryProvider;
